import React from 'react'
import { css } from '@linaria/core'
import { H3, Paragraph, Separator, Subheading } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'

const ageCss = css`
  color: #cc0066;
  font-weight: initial;
  font-size: 12px;
  margin-top: -4px;
`

/**
 * Text component for WorldEvents info card.
 * @param {object} props - Props
 * @returns {JSX} Component
 */
export default function EventText({ year, birthYear, title, text }) {
  const [t] = useTranslation()
  const titleText = title ? `${year} · ${title}` : year
  let ageString = ''

  if (birthYear) {
    ageString = <span className={ageCss}>{t('info-cards.world-events.age', { age: year - birthYear })}</span>
  }

  return (
    <div>
      <H3 size="H5" supplementary>
        {titleText}
        <Subheading>{ageString}</Subheading>
      </H3>
      <Separator size="nano" />
      <Paragraph size="sm">{text}</Paragraph>
      <Separator size="md" />
    </div>
  )
}
